import { render } from "./socialWorkForm.vue?vue&type=template&id=e9fafb28&scoped=true"
import script from "./socialWorkForm.vue?vue&type=script&lang=js"
export * from "./socialWorkForm.vue?vue&type=script&lang=js"

import "./socialWorkForm.vue?vue&type=style&index=0&id=e9fafb28&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fafb28"]])

export default __exports__